import React, { useState } from 'react';
import { AsyncSelect } from '../../../common/components/Select/Select';
import { getAdminCalendarDesigners } from '../api/AdminCalendarApi';

const BookingReassignDesigner = ({ designer, calendar, className, onDesignerChange }) => {
  const [designers, setDesigners] = useState([designer]);

  const styles = {};

  const NOT_ASSIGNED_OPTION = { label: 'not reassigned', value: null };
  const defaultOptions =
    designer ? [NOT_ASSIGNED_OPTION, { label: `${designer.full_name} <${designer.email}>`, value: designer.id }] : [NOT_ASSIGNED_OPTION];

  const valueFromId = (opts, id) => opts.find(o => o.value === id);

  const onDesignerOptionChange = option => {
    let newDesigner = null;
    if (option && option.value) {
      newDesigner = designers.find(item => item.id === option.value);
    }
    onDesignerChange(newDesigner);
  };

  const prepareUserValues = designersArray => {
    const initial = [NOT_ASSIGNED_OPTION];
    const prepared = designersArray.reduce((acct, d) => {
      acct.push({ value: d.id, label: `${d.full_name} <${d.email}>` });
      return acct;
    }, initial);
    return prepared;
  };

  const handleLoadOptions = (search, callback) => {
    getAdminCalendarDesigners(
      calendar,
      search,
      data => {
        setDesigners(data.designers);
        callback(prepareUserValues(data.designers));
      },
      error => {
        console.log(error);
      },
    );
    return null;
  };

  const value = valueFromId(defaultOptions, designer && designer.id);
  return (
    <div className={`${className}`}>
      <AsyncSelect
        loadOptions={handleLoadOptions}
        value={value}
        onChange={onDesignerOptionChange}
        defaultOptions={defaultOptions}
        styles={styles}
      />
    </div>
  );
};

export default BookingReassignDesigner;



// WEBPACK FOOTER //
// ./app/javascript/components/designer_calendars/components/BookingReassignDesigner.js